<template>
    <div class="page-wrapper" v-if="$route.name!=='Set Password' && $route.name!=='Reset Password' && $route.name!=='App Store'">
        <div class="">
            <Header v-if="showShellLayout" />
        </div>
        <div class="page-body-wrapper">
            <Sidebar v-if="showShellLayout" class="page-sidebar" />
            <div class="page-body" :class="{ 'page-body--fullbleed': !showShellLayout }">
                <!-- Key by route only; terminology updates via terminologyRevision in i18n/filters (not full remount). -->
                <router-view :key="$route.fullPath" />
            </div>
            <Footer v-if="showShellLayout" />
            <!-- END PAGE CONTENT -->
        </div>
        <!-- END MAIN CONTENT -->
    </div>
    <div class="page-wrapper" v-if="$route.name=='Set Password' || $route.name=='Reset Password' || $route.name=='App Store'">
        <div class="page-body">
            <router-view />
        </div>
    </div>
    <AppChatbot v-if="showChatbot" />
</template>

<script>
    import Header from "@/layouts/header/Header.vue"
    import Sidebar from '@/layouts/sidebar/Sidebar.vue';
    import Footer from "@/layouts/footer/footer.vue";
    import AppChatbot from "@/layouts/ChatBot/chatbot.vue";
    import { initShellLayoutWhenReady } from '@/helpers/shellLayout';
    //import minJs from "@/assets/CustomJs/jquery-3.4.1.min.js"
    //import boostrp from "@/assets/CustomJs/bootstrap.min.js"
    //import customjs from "@/assets/CustomJs/front.js"

    export default {
        name: 'LayoutName',
        components: {
            Header,
            Sidebar, Footer, AppChatbot
        },
        created() {
            
            //alert(this.$route.name);
            //var scripts = [
            //    "https://portal.orbistream.com/assets/js/front.js"

            //];
            //scripts.forEach(script => {
            //    let tag = document.createElement("script");
            //    tag.setAttribute("src", script);
            //    document.head.appendChild(tag);

            //});
        },
        mounted() {
            this.scheduleShellLayoutSync();
        },
        watch: {
            showShellLayout(visible) {
                if (visible) {
                    this.scheduleShellLayoutSync();
                }
            }
        },
        methods: {
            scheduleShellLayoutSync() {
                this.$nextTick(() => {
                    initShellLayoutWhenReady();
                });
            }
        },
        computed: {
            isChecklistPopupMode() {
                return this.$route?.path === '/onboardinglist' && this.$route?.query?.checklistPopup === 'true';
            },
            isAuthOnlyPage() {
                return this.$route.name === 'Set Password'
                    || this.$route.name === 'Reset Password'
                    || this.$route.name === 'App Store';
            },
            showShellLayout() {
                // Re-evaluate when route changes so shell appears after client-side post-login navigation.
                void this.$route?.fullPath;
                const token =
                    localStorage.getItem("access_token") ||
                    localStorage.getItem("access_Token");
                return token != null &&
                    token !== '' &&
                    this.$route.name !== 'login' && this.$route.name !=='account/resetpassword' && 
                    !this.$route.meta?.hideLayout &&
                    !this.isChecklistPopupMode;
            },
            showChatbot() {
                const userType = localStorage.getItem("userType");
                return !this.$route.meta?.hideLayout
                    && !this.isChecklistPopupMode
                    && !this.isAuthOnlyPage
                    && !['usertype11', 'usertype12','usertype22'].includes(userType);
            }
        }

    }
</script>

<style>
/* When Header/Sidebar are hidden (meta.hideLayout), remove the reserved sidebar/header space. */
.page-body-wrapper .page-body.page-body--fullbleed {
    margin-left: 0 !important;
    margin-top: 0 !important;
    padding: 0 !important;
    min-height: 100vh !important;
    background: transparent !important;
}
</style>